import { render, staticRenderFns } from "./CatchCropForm.vue?vue&type=template&id=2f3f8254&scoped=true&lang=html&"
import script from "./CatchCropForm.vue?vue&type=script&lang=js&"
export * from "./CatchCropForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3f8254",
  null
  
)

export default component.exports